var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        { name: "show", rawName: "v-show", value: _vm.open, expression: "open" }
      ],
      staticClass: "ns-dropdown-modal__temp-container",
      on: {
        click: function($event) {
          $event.stopPropagation()
        }
      }
    },
    [
      _c("div", { staticClass: "ns-dropdown-modal__temp-inner" }, [
        _c(
          "div",
          { staticClass: "modal-content" },
          [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showCustomInput,
                    expression: "showCustomInput"
                  }
                ],
                staticClass: "back-button",
                on: { click: _vm.handleBack }
              },
              [
                _c("NsIcon", {
                  staticClass: "back-button-icon",
                  attrs: { "icon-name": "icon-chevron-left" }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "close-button",
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              },
              [_c("NsIcon", { attrs: { "icon-name": "icon-close" } })],
              1
            ),
            _vm._v(" "),
            _c("h3", { staticClass: "modal-title" }, [
              _vm._v("\n        " + _vm._s(_vm.title) + "\n      ")
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.showCustomInput,
                    expression: "showCustomInput"
                  }
                ],
                staticClass: "ns-dropdown-modal__custom-input"
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "ns-dropdown-modal__custom-input--border",
                    class: {
                      "ns-dropdown-modal__custom-input-error": _vm.errorMessage
                    }
                  },
                  [
                    _vm._t("custom"),
                    _vm._v(" "),
                    _c(
                      "p",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.errorMessage,
                            expression: "errorMessage"
                          }
                        ],
                        staticClass: "ns-dropdown-modal__error-tag"
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.errorMessage) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "fluid primary-solid",
                    attrs: { disabled: !!_vm.errorMessage },
                    on: {
                      click: function($event) {
                        return _vm.$emit("close")
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.translations.done) +
                        "\n        "
                    )
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "NsSlottedDropdownItems",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: !_vm.showCustomInput,
                    expression: "!showCustomInput"
                  }
                ],
                attrs: {
                  selected: _vm.selected,
                  "using-custom": _vm.usingCustom,
                  modal: ""
                },
                on: { select: _vm.handleSelect }
              },
              [_vm._t("default")],
              2
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }